import * as v3 from './v3/form';
import * as v5 from './v5/form';

const impl = process.env.NODE_CONFIG?.backend?.version === 'v5' ? v5 : v3;

export const { parseForm, formatForm } = impl;
